import api from 'axios'

/**
 * Signal types
 */
export const LOAD_CALL_FOR_APPLICATIONS = 'abl-backoffice/callForApplication/LOAD_CALL_FOR_APPLICATIONS'
export const LOAD_CALL_FOR_APPLICATION = 'abl-backoffice/callForApplication/LOAD_CALL_FOR_APPLICATION'
export const RESET_ALL = 'abl-backoffice/callForApplication/RESET_ALL'
export const RESET_ONE = 'abl-backoffice/callForApplication/RESET_ONE'
export const LOAD_CURRENT = 'abl-backoffice/callForApplication/LOAD_CURRENT'
export const RESET_CURRENT = 'abl-backoffice/callForApplication/RESET_CURRENT'

/**
 * Action for fetching application item.
 *
 * @param callForApplication
 * @returns {function(*)}
 */
export const fetchOne = (callForApplication) => {

	const request = api.get('/webapi/call-for-application/' + callForApplication)

	return dispatch => {
		return request.then(response => {
			dispatch(loadOne(response.data))
			return {data: response.data}
		})
	}
}

// /**
//  * Action to initialize a call for application item.
//  *
//  * @returns {{type, data: *}}
//  */
// export const initializeOne = () => {
//
// 	const publicationDate = moment()
// 	publicationDate.set({
// 		hour: 12,
// 		minute: 0
// 	})
//
// 	const applicationDeadline = moment()
// 	applicationDeadline.set({
// 		hour: 16,
// 		minute: 30
// 	})
//
// 	return loadOne({
// 		publicationDate: publicationDate.format(),
// 		applicationDeadline: applicationDeadline.format()
// 	})
// }
//
// /**
//  * @param {object} values
//  * @returns {Promise.<T>}
//  */
// export const create = function(values) {
// 	const sanitizedValues = sanitizeValues(values)
//
// 	const request = api.post('/api/call-for-application', {
// 		callForApplication: sanitizedValues,
// 		__csrfToken: $('#csrf-token').data('csrf-token')
// 	})
//
// 	return dispatch => {
// 		return request
// 			.then(response => {
//
// 				dispatch(loadOne(response.data))
//
// 				// Refresh form with data coming from the server.
// 				// Should be triggered in order to set the form to pristine
// 				// http://redux-form.com/6.0.0-alpha.4/docs/api/ActionCreators.md/#/api/reduxForm
// 				// http://redux-form.com/6.0.0-alpha.4/examples/initializeFromState/
// 				// dispatch(initialize('callForApplicationForm', response.data))
//
// 				// reset all call for application items
// 				dispatch(resetAll)
// 				return response.data
// 			})
// 			.catch(response => {
// 				return Promise.reject(response.data)
// 			})
// 	}
// }
//
// /**
//  * @param {object} values
//  * @returns {Promise.<T>}
//  */
// export const update = function(values) {
// 	const sanitizedValues = sanitizeValues(values)
//
// 	const request = api.put('/api/call-for-application', {
// 		callForApplication: sanitizedValues,
// 		__csrfToken: $('#csrf-token').data('csrf-token')
// 	})
//
// 	return dispatch => {
// 		return request
// 			.then(response => {
//
// 				dispatch(loadOne(response.data))
//
// 				// reset all call for application items
// 				dispatch(resetAll)
//
// 				return response.data
//
// 			})
// 			.catch(response => {
// 				return Promise.reject(response.data)
// 			})
// 	}
// }

/**
 * @param values
 * @returns {{}}
 */
// const sanitizeValues = function(values) {
// 	delete values.numberOfCallForApplicationItems
// 	return values
// }
//
// /**
//  * Actions to remove one item.
//  */
// export const remove = callForApplication => {
// 	const request = api.delete('/api/call-for-application/' + callForApplication, {
// 		data: {__csrfToken: $('#csrf-token').data('csrf-token')},
// 	})
//
// 	return dispatch => {
// 		return request.then(response => response.data)
// 	}
// }
//
// /**
//  * Action for fetching call application items.
//  *
//  * @returns {function(*)}
//  */
// export const fetchAll = () => {
//
// 	const request = api.get('/api/call-for-applications')
//
// 	return dispatch => {
// 		return request.then(response => {
// 			dispatch(loadAll(response.data))
// 			return response.data
// 		})
// 	}
// }

/**
 * Action for fetching call application items.
 *
 * @returns {function(*)}
 */
export const fetchCurrent = (specialCallForApplication) => {

  // set to (expected) string 'current' if 'null' or 'undefined'
  if(specialCallForApplication === null) { specialCallForApplication = 'current' }
	const request = api.get('/webapi/call-for-application/' + specialCallForApplication)

	return dispatch => {
    return request.then(response => {
      dispatch(loadCurrent(response.data))
      return {data: response.data}
    }).catch(error => {
      console.error('Error fetching current call for application:', error)
      return { error: 'Failed to fetch current call for application.' }
    })

  }
}

/**
 * Action to export documents
 *
 * @param {Array} callForApplication
 * @returns {function(*)}
 */
// export const exportPendingNotifications = (callForApplication) => {
// 	const request = api.post('/api/call-for-application/export-documents', {
// 		callForApplication: callForApplication,
// 		__csrfToken: $('#csrf-token').data('csrf-token'),
// 	})
//
// 	return dispatch => {
// 		return request.then(response => {
// 			return response.data
// 		})
// 	}
// }

/**
 * @param {Array} data
 */
// export const loadAll = data => ({type: LOAD_CALL_FOR_APPLICATIONS, data})
//
/**
 * @param {object} data
 */
export const loadOne = data => ({type: LOAD_CALL_FOR_APPLICATION, data})
//
// /**
//  * Action to reset all applications
//  */
// export const resetAll = () => ({type: RESET_ALL})
//
// /**
//  * Action to reset one application
//  */
// export const resetOne = () => ({type: RESET_ONE})

export const loadCurrent = data => ({type: LOAD_CURRENT, data})
export const resetCurrent = () => ({type: RESET_CURRENT})
